// APP
export const DRAWER = 'DRAWER'
export const DRAWER_TOGGLE = 'DRAWER_TOGGLE'
export const FULLSCREEN = 'FULLSCREEN'

// Auth
export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_ERROR = 'AUTH_ERROR'

// User
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'

// Catalogs
export const FETCH_CATALOGO_ESTADOS = 'FETCH_CATALOGO_ESTADOS'
export const FETCH_CATALOGO_ESTADOS_SUCCESS = 'FETCH_CATALOGO_ESTADOS_SUCCESS'
export const FETCH_CATALOGO_ESTADOS_FAILURE = 'FETCH_CATALOGO_ESTADOS_FAILURE'

// NOTIFICATION
export const NEW_UPDATE = 'NEW_UPDATE'

// PUSH NOTIFICATIONS
export const PUSH_NOTIFICATION = 'PUSH_NOTIFICATION'
export const PUSH_NOTIFICATION_UNSUBSCRIBE = 'PUSH_NOTIFICATION_UNSUBSCRIBE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js